import { atom } from "jotai";

export const useChatGPTAtom = atom<boolean>(false);
